'use strict';

DoohApps
    .factory('ApplicationHelper', ['$filter', 'appStoreBLL', 'DialogHandler', 'FileUploadHelper', 'campaignBLL', 'ConfigurationBlockHelper', 'CompanyBLL', 'MediaAssetsBLL', '$timeout', '$location', 'SessionData', '$route', '$q', 'modal2', 'FileDownloadHelper', 'User',
        function ($filter, _appStore, DialogHandler, FileUploadHelper, campaignBLL, ConfigBlockHelper, _company, MediaAssetsBLL, $timeout, $location, SessionData, $route, $q, modal2, FileDownloadHelper, User) {
            var deleteBlockID;
            var newFiles = [];
            var deleteFileID = undefined;
            var AddSelectedFiles = {
                ApplicationVersionFileList: []
            };
            var deleteExeActionID;
            var DelAppID;
            var removeReqList = [];
            var deleteBlockList = [];
            var groupDelete;
            var versionCopy = false;
            var replaceLists;
            var addLists;

            var blockType = ConfigBlockHelper.configurationBlockType;

            return {
                GetInteractionTypes: function ($scope) {
                    _appStore.GetInteractionTypes(function (data) { $scope.InteractionTypes = data; }); //get list of InteractionTypes
                },
                LoadApps: function ($scope, bll) {
                    loadApps($scope, bll);
                },
                GetAppVerList: function ($scope, bll, appId) {
                    if (appId == undefined) {
                        if ($scope.CopyAppInfo.ApplicationId != '') {
                            bll.getAppVersionListByAppId(function (data) {
                                $scope.appVersionList = data.content;
                            }, $scope.CopyAppInfo.ApplicationId);
                        }
                        else {
                            $scope.appVersionList = [];
                        }
                    }
                    else {
                        bll.getAppVersionListByAppId(function (data) {
                            $scope.appVerList = data.content;
                            angular.forEach($scope.appVerList, function (ver) {
                                if (ver.ApplicationID == appId && ver.IsActive == true)
                                    $scope.currentVersion.ver = ver;
                            });
                        }, appId);
                    }
                },
                NewAppModel: function (dev, modal, $scope, formHelper, thisapp, CampaignDataFilter) {
                    if (modal.open('AppEdit', '', 'static')) {
                        this.GetInteractionTypes($scope);

                        if (dev) {
                            $scope.CompanyName = undefined;
                            angular.forEach($scope.vendorList, function (vendor) {
                                if (vendor.CompanyID === User.company.id) $scope.CompanyName = vendor.Title;
                            });
                            $scope.Configurator = undefined;
                            formHelper.ResetFormErrors();
                            if ($scope.CompanyName == undefined) $scope.formError = 'Company is not application provider!'
                        }

                        CampaignDataFilter.setConfiguratorBlocks(function () {
                            $scope.configuratorBlocks = CampaignDataFilter.ConfiguratorBlocks;
                            $scope.blockChange = 0;
                        });

                        $scope.Configurator = undefined;
                        $scope.isNewApp = true;
                        $scope.currentVersion = {};
                        $scope.SelectedApplication = thisapp;
                        $scope.application = undefined;
                        $scope.appVerList = undefined;

                        $scope.editTabs.Active = 'Basic';
                        $scope.editTabs.editVersionTabs = 'Version'
                        $scope.newMediaList = [];
                        $scope.removeMediaList = [];
                        $scope.defaultThumbnail = {};

                        $scope.showBigger = {};

                        var format = localStorage['ShortDateFormat'].replace(/d/g, 'D').replace(/y/g, 'Y');

                        $scope.AppDetailsForm = {
                            ApplicationID: 0,
                            Description: '',
                            ShortDescription: '',
                            ApplicationTitle: '',
                            InteractionID: '',
                            Price: 0,
                            RentingPrice: 0,
                            State: '',
                            UrlLink: '',
                            IsExternal: false,
                            _OrderDate: moment().format(format)
                        };

                        $scope.AppVerDetailsForm = {
                            Version: '',
                            ApplicationVersionID: 0,
                            IsActive: false,
                            ConfigurationExternalURL: '',
                            ExecutableName: '',
                            Description: '',
                            Status: 'Development',
                            CreateAppExternalURL: '',
                            DeleteAppExternalURL: '',
                            CopyAppExternalURL: '',
                            CopyAppExternalUrlPOST: '',
                            InAppSwitch: false,
                            AutoSave: true
                        };

                        $scope.EditableShowBigger = angular.copy($scope.showBigger);
                    }
                },
                EditAppModel: function (dev, $scope, modal, bll, CampaignDataFilter, copy, thisapp, formHelper) {
                    var finallyCallback = function () {
                        if (!$scope.$$destroyed) {
                            $scope.AppDetailsForm = {};
                            $route.current.params = {};
                            setRoute('Applications');
                        }
                    }

                    if (modal.open('AppEdit', 'appEditModal', 'static', {
                        finallyCallback: finallyCallback
                    })) {
                        var appId = copy ? $scope.application.ApplicationID : thisapp.ApplicationID;

                        setRoute('Applications/' + appId);
                        $scope.assetpath = undefined;
                        $scope.mediaSelected = false;
                        $scope.CustomCode = {};
                        $scope.groupList = undefined;//list all group names
                        $scope.Configurator = undefined;

                        CampaignDataFilter.setConfiguratorBlocks(function () {
                            $scope.configuratorBlocks = CampaignDataFilter.ConfiguratorBlocks;
                            $scope.blockChange = 0;
                        });

                        $scope.appLoading = true;
                        this.GetInteractionTypes($scope);
                        $scope.isNewApp = false;

                        $scope.currentVersion = {};
                        $scope.SelectedApplication = copy ? $scope.application : thisapp;
                        $scope.noChgAllowed = false;
                        bll.getAppVersionListByAppId(function (data) {
                            if (data.hasError) {
                                DialogHandler.AddError(data.error);
                                modal.dismiss('AppEdit');
                                return;
                            }
                            $scope.appVerList = data.content;
                            angular.forEach($scope.appVerList, function (ver) {
                                if (typeof ($scope.currentVersion.ver) === 'undefined') {
                                    if (typeof ($route.current.params.version) != 'undefined') {
                                        if (ver.ApplicationID == appId && ver.Version == $route.current.params.version)
                                            $scope.currentVersion.ver = ver;
                                    }
                                    else {
                                        if (ver.ApplicationID == appId && ver.IsActive == true)
                                            $scope.currentVersion.ver = ver;
                                        if (dev && $scope.noChgAllowed == false) {
                                            if (ver.Status == 'Public') $scope.noChgAllowed = true;
                                        }
                                    }
                                }
                            });
                            $scope.editTabs.Active = typeof ($route.current.params.appTab) != 'undefined' ? $route.current.params.appTab : 'Basic';
                            $scope.editTabs.editVersionTabs = typeof ($route.current.params.versionSection) != 'undefined' ? $route.current.params.versionSection : 'Version'
                            $scope.newMediaList = [];
                            $scope.removeMediaList = [];
                            $scope.defaultThumbnail = {};

                            bll.GetAppByIdAdmin(function (data) {
                                if (data.error_description !== undefined) {
                                    DialogHandler.AddError(data.error_description);
                                    modal.dismiss('AppEdit');
                                    return;
                                }
                                $scope.application = data.Data.Content;
                                $scope.showBigger = {};
                                getAppImages($scope);

                                $scope.showBigger.FileUrl = $scope.application.MainScreenURL;
                                if ($scope.application.AttchedAssetFiles && $scope.application.AttchedAssetFiles.constructor === Array) {
                                    for (var i = 0; i < $scope.application.AttchedAssetFiles.length; i++) {
                                        if ($scope.application.AttchedAssetFiles[i].isDefault === true) {
                                            $scope.showBigger.MediaAssetID = $scope.application.AttchedAssetFiles[i].MediaAssetID;
                                        }
                                    }
                                }

                                var format = localStorage['ShortDateFormat'].replace(/d/g, 'D').replace(/y/g, 'Y');

                                formHelper.ResetFormErrors();
                                $scope.AppDetailsForm = {
                                    ApplicationID: $scope.application.ApplicationID,
                                    Description: $scope.application.Description,
                                    ShortDescription: $scope.application.ShortDescription,
                                    ApplicationTitle: $scope.application.ApplicationTitle,
                                    InteractionID: $scope.application.InteractionID,
                                    Price: $scope.application.Price,
                                    RentingPrice: $scope.application.RentingPrice,
                                    State: $scope.application.State,
                                    UrlLink: $scope.application.UrlLink,
                                    IsExternal: $scope.application.IsExternal,
                                    IsBackground: $scope.application.IsBackground,
                                    IsWebApp: $scope.application.IsWebApp,
                                    IsServiceApp: $scope.application.IsServiceApp,
                                    _OrderDate: moment($scope.application.OrderDate).format(format)
                                };

                                $scope.AppVerDetailsForm = {
                                    Version: $scope.application.Version,
                                    ApplicationVersionID: $scope.application.ApplicationVersionID,
                                    IsActive: $scope.application.IsActive,
                                    ConfigurationExternalURL: $scope.application.ConfigurationExternalURL,
                                    ExecutableName: $scope.currentVersion.ver.ExecutableName,
                                    Description: $scope.application.ChangeLog,
                                    Status: $scope.application.Status,
                                    CreateAppExternalURL: $scope.application.CreateAppExternalURL,
                                    DeleteAppExternalURL: $scope.application.DeleteAppExternalURL,
                                    CopyAppExternalURL: $scope.application.CopyAppExternalURL,
                                    CopyAppExternalUrlPOST: $scope.application.CopyAppExternalUrlPOST,
                                    InAppSwitch: $scope.currentVersion.ver.InAppSwitch,
                                    AutoSave: $scope.currentVersion.ver.AutoSave
                                };

                                if (dev) {
                                    $scope.noChangeAllowed = false;
                                    if ($scope.AppVerDetailsForm.Status == 'Public') $scope.noChangeAllowed = true;
                                }

                                if (typeof ($route.current.params.versionSection) != 'undefined')
                                    $scope.switchEditVersionTab($route.current.params.versionSection);
                                else if (typeof ($route.current.params.appTab) != 'undefined')
                                    $scope.switchEditTab($route.current.params.appTab);

                                $scope.EditableShowBigger = angular.copy($scope.showBigger);
                                $scope.appLoading = false;
                            }, appId, copy ? $scope.application.ApplicationVersionID : $scope.currentVersion.ver.ApplicationVersionID);
                        }, appId);
                    }
                },
                UpdateAppDetails: function ($scope, bll, modal, close) {
                    if ($scope.forms.editAppForm.$valid && !$scope.FormSent) {
                        $scope.FormSent = true;
                        if ($scope.forms.editAppForm.$dirty == true && $scope.forms.editAppForm.$pristine == false) {
                            var format = localStorage['ShortDateFormat'].replace(/d/g, 'D').replace(/y/g, 'Y');
                            var regex = /^([0-9]{4}-[0-9]{1,2}-[0-9]{1,2}(\s[0-9]{1,2}:[0-9]{2})?)$/;
                            if (!regex.test($scope.AppDetailsForm._OrderDate))
                                $scope.AppDetailsForm.OrderDate = moment($scope.AppDetailsForm._OrderDate, format).format('YYYY-MM-DD');
                            else $scope.AppDetailsForm.OrderDate = null;

                            bll.UpdateApp(function (data) {
                                $scope.FormSent = false;
                                if (data.hasError) {
                                    DialogHandler.AddError(data.error);
                                } else {
                                    if (close == 'true') modal.close('AppEdit');
                                    DialogHandler.AddMessage('App Info Updated!');
                                    $scope.application.ApplicationTitle = $scope.AppDetailsForm.ApplicationTitle;

                                    loadApps($scope, bll);
                                }
                            }, $scope.AppDetailsForm);
                        }
                        else {
                            if (close == 'true') modal.close('AppEdit');
                            $scope.FormSent = false;
                            DialogHandler.AddMessage('No changes were detected!');
                        }
                    }
                },
                DeleteAppCheck: function ($scope, modal, bll, app, version) {
                    if (modal.open('DeleteApp', 'inviteColleagueModal', 'static')) {
                        $scope.dataLoading = true;
                        $scope.DelMessage = '';
                        if (app != undefined) DelAppID = app.ApplicationID;
                        if (version == undefined) {
                            $scope.checkVersion = false;
                            bll.checkAppBeforeDelete(function (data) {
                                $scope.dataLoading = false;
                                if (data.error_description != undefined) {
                                    $scope.DelMessage = data.error_description;
                                    $scope.cantDel = true;
                                }
                                else {
                                    $scope.cantDel = false;
                                    $scope.DelMessage = 'Are you sure you want to delete \'' + app.ApplicationTitle + '\'?';
                                }
                                $scope.confirmationPressed = true;
                            }, app.ApplicationID);
                        }
                        else {
                            $scope.checkVersion = true;
                            bll.checkAppVerBeforeDelete(function (data) {
                                $scope.dataLoading = false;
                                if (data.error_description != undefined) {
                                    $scope.DelMessage = data.error_description;
                                    $scope.cantDel = true;
                                }
                                else {
                                    $scope.cantDel = false;
                                    $scope.DelMessage = 'Are you sure you want to delete version \'' + version.Version + '\'?';
                                }
                                $scope.confirmationPressed = true;
                            }, version.ApplicationVersionID);
                        }
                    }
                },
                DeleteApp: function ($scope, bll, modal) {
                    if (!$scope.cantDel && !$scope.checkVersion) {
                        $scope.confirmationPressed = false;
                        bll.deleteApp(function (data) {
                            if (data.error_description != undefined) {
                                DialogHandler.AddError(data.error_description);
                            }
                            else {
                                DialogHandler.AddMessage('Delete successful!');
                                loadApps($scope, bll);
                            }
                            $scope.confirmationPressed = true;
                            modal.close('DeleteApp');
                        }, DelAppID)
                    }
                },
                DeleteAppVer: function (dev, $scope, bll, modal, formHelper) {
                    $scope.confirmationPressed = false;
                    var removeVersionID = $scope.AppVerDetailsForm.ApplicationVersionID;
                    bll.deleteAppVersion(function (data) {
                        if (data.error_description != undefined) {
                            DialogHandler.AddError(data.error_description);
                        }
                        else {
                            DialogHandler.AddMessage('Delete successful!');
                            var idx = -1;
                            angular.forEach($scope.appVerList, function (version, key) {
                                if (version.ApplicationVersionID == removeVersionID) idx = key;
                            });
                            $scope.appVerList.splice(idx, 1);
                            $scope.currentVersion.ver = $scope.appVerList[$scope.appVerList.length - 1];
                            reloadVersion(dev, $scope, bll, formHelper)
                        }
                        $scope.confirmationPressed = true;
                        modal.close('DeleteApp');
                    }, $scope.AppVerDetailsForm.ApplicationVersionID)
                },
                ResetUrlLinkError: function (formError) {
                    if (formError == 'Name in URL exists for another application!')
                        formError = '';
                },
                CreateNewApp: function (dev, $scope, bll, modal, close, formHelper) {
                    if ($scope.forms.editAppForm.$valid && !$scope.FormSent) {
                        $scope.FormSent = true;

                        if ($scope.forms.editAppForm.$dirty == true && $scope.forms.editAppForm.$pristine == false) {
							if (dev) $scope.AppDetailsForm.CompanyID = User.company.id;
                            else $scope.AppDetailsForm.CompanyID = $scope.AppDetailsForm.CompanyObject.CompanyID;
                            $scope.appLoading = true;
                            bll.AddNewApp(function (data) {
                                $scope.FormSent = false;
                                if (data.error_description) {
                                    $scope.formError = data.error_description;
                                    $scope.appLoading = false;
                                } else {
                                    $scope.application = {};
                                    $scope.application.ApplicationID = data.Data.Content;
                                    if ($scope.application.ApplicationID == 0) {
                                        $scope.application = undefined;
                                        $scope.formError = 'Could not save application!';
                                        $scope.FormSent = false;
                                    }
                                    else {
                                        $scope.AppDetailsForm.ApplicationID = data.Data.Content;
                                        $scope.application.ApplicationTitle = $scope.AppDetailsForm.ApplicationTitle;
                                        $scope.isNewApp = false;

                                        bll.getAppVersionListByAppId(function (data) {
                                            $scope.appVerList = data.content;
                                            angular.forEach($scope.appVerList, function (ver) {
                                                if (ver.ApplicationID == $scope.application.ApplicationID && ver.IsActive == true)
                                                    $scope.currentVersion.ver = ver;
                                            });
                                            bll.GetAppByIdAdmin(function (data) {
                                                $scope.application = data.Data.Content;
                                                $scope.showBigger = {};
                                                getAppImages($scope);

                                                $scope.showBigger.FileUrl = $scope.application.MainScreenURL;

                                                formHelper.ResetFormErrors();

                                                $scope.AppVerDetailsForm = {
                                                    Version: $scope.application.Version,
                                                    ApplicationVersionID: $scope.application.ApplicationVersionID,
                                                    IsActive: $scope.application.IsActive,
                                                    ConfigurationExternalURL: $scope.application.ConfigurationExternalURL,
                                                    ExecutableName: $scope.currentVersion.ver.ExecutableName,
                                                    Description: $scope.application.ChangeLog,
                                                    Status: $scope.application.Status,
                                                    CreateAppExternalURL: $scope.application.CreateAppExternalURL,
                                                    DeleteAppExternalURL: $scope.application.DeleteAppExternalURL,
                                                    CopyAppExternalURL: $scope.application.CopyAppExternalURL,
                                                    CopyAppExternalUrlPOST: $scope.application.CopyAppExternalUrlPOST,
                                                    InAppSwitch: $scope.currentVersion.ver.InAppSwitch,
                                                    AutoSave: $scope.currentVersion.ver.AutoSave
                                                };

                                                $scope.EditableShowBigger = angular.copy($scope.showBigger);
                                                $scope.appLoading = false;
                                            }, $scope.application.ApplicationID, $scope.currentVersion.ver.ApplicationVersionID)
                                        }, $scope.application.ApplicationID);
                                    }

                                    loadApps($scope, bll);
                                }
                            }, $scope.AppDetailsForm);
                        }
                        else {
                            if (close == 'true') modal.close('AppEdit');
                            $scope.FormSent = false;
                        }
                    }
                },
                UpdateAppVersion: function ($scope, bll, modal, close) {
                    if ($scope.forms.editAppVerForm.$valid && !$scope.noChangeAllowed && !$scope.FormSent) {
                        $scope.FormSent = true;
                        if ($scope.forms.editAppVerForm.$dirty == true && $scope.forms.editAppVerForm.$pristine == false) {
                            bll.updateAppVersion(function (data) {
                                $scope.FormSent = false;
                                if (data.hasError) {
                                    DialogHandler.AddError(data.error);
                                    loadApps($scope, bll);
                                } else {
                                    if (close == 'true') modal.close('AppEdit');
                                    else $scope.application.VersionUpdateDate = data.content.UpdateDate || data.content;
                                    DialogHandler.AddMessage('App Version Updated!');

                                    loadApps($scope, bll);
                                }
                            }, $scope.AppVerDetailsForm);
                        }
                        else {
                            if (close == 'true') modal.close('AppEdit');
                            $scope.FormSent = false;
                            DialogHandler.AddMessage('No changes were detected!');
                        }
                    }
                },
                OpenNewVersionModal: function (dev, $scope, bll, formHelper, copy) {
                    var modalObj = {
                        name: 'NewAppVersion',
                        windowClass: 'loginModal simpleFormModal',
                        resolvedCallback: function (data) {
                            $scope.appVerList.push(data);
                            $scope.AppVerDetailsForm = $scope.currentVersion.ver = data;
                            $scope.application.ApplicationVersionID = data.ApplicationVersionID;
                            $scope.verFilesList = data.ApplicationVersionFiles;
                            reloadVersion(dev, $scope, bll, formHelper, copy);
                            loadApps($scope, bll);
                        },
                        passObj: {
                            ApplicationID: $scope.application.ApplicationID,
                            lastVersion: $scope.appVerList[$scope.appVerList.length - 1].Version,
                            bll: bll
                        }
                    };
                    modal2.open(modalObj);
                },
                SwitchEditVersionTab: function ($scope, bll, tab, reload) {
                    switchEditVersionTab($scope, bll, tab, reload);
                },
                ReloadVersion: function (dev, $scope, bll, formHelper, copy) {
                    reloadVersion(dev, $scope, bll, formHelper, copy);
                },
                SwitchEditTab: function ($scope, bll, tab) {
                    $scope.editTabs.Active = tab;
                    switch (tab) {
                        case 'Versions':
                            $scope.editVersionTabs.Active = 'Version';
                            loadVersionFiles($scope, bll);

                            break;
                    }
                    setRoute('Applications/' + $scope.application.ApplicationID + '/' + tab);
                },
                //Version files
                OpenNewVersionFileModal: function ($scope, modal) {
                    if (modal.open('newVersionFile', 'inviteColleagueModal', 'static', { finallyCallback: function () { $scope.AddNewVersionFile = {}; } })) {
                        $scope.uploadError = '';
                        $scope.Error = '';
                        $scope.validationFailed = false;
                        newFiles = [];
                        $scope.writeWarnings = [];
                        $scope.writeErrors = [];
                        $scope.validating = false;
                        $scope.AddNewVersionFile = {};
                        $scope.AddNewVersionFile.HasFile = false;
                        $scope.AddNewVersionFile.Files = [];
                        $scope.FormSent = false;
                    }
                },
                ValidateNewAppFiles: function (dev, form, $scope, bll) {
                    form.$setPristine();
                    $scope.validating = true;
                    $scope.validationFailed = false;
                    newFiles = [];
                    $scope.writeWarnings = [];
                    $scope.writeErrors = [];
                    $scope.FormSent = true;
                    $scope.Error = '';
                    $scope.uploadError = '';

                    if ($scope.AddNewVersionFile.HasFile == true) {
                        angular.forEach($scope.AddNewVersionFile.Files, function (file) {
                            file.uploadLinkRecieved = false;
                        });
                        FileUploadHelper.ValidateNewAppFiles(dev, function (data) {
                            $scope.validating = false;
                            $scope.FormSent = false;
                            $scope.validationFailed = true;
                            newFiles = data.files;
                            $scope.writeWarnings = data.warnings;
                            $scope.writeErrors = data.errors;
                            for (var i = 0; i < $scope.AddNewVersionFile.Files.length; i++)
                                $scope.AddNewVersionFile.Files[i].FileID = newFiles[i].fileID;
                        }, $scope, bll);
                    }
                },
                SaveNewVersionFile: function ($scope, bll) {
                    $scope.FormSent = true;
                    $scope.Error = '';
                    $scope.uploadError = '';
                    $scope.validating = false;
                    if ($scope.AddNewVersionFile.HasFile)
                        FileUploadHelper.AddVersionFile($scope, newFiles, bll);
                },
                NewVersionFileAdded: function ($scope, bll, data, idx, modal, UpLoadedFilesCount) {
                    if (data.hasError == false) {
                        if (UpLoadedFilesCount == $scope.AddNewVersionFile.Files.length) {
                            if ($scope.FileCount == 0 || typeof $scope.FileCount == 'undefined') {
                                var error = false;
                                $scope.Error = '';
                                angular.forEach($scope.AddNewVersionFile.Files, function (file) {
                                    if (file.Error != undefined && file.Error != '') {
                                        error = true;
                                        $scope.Error += file.Error + '<br/>';
                                    }
                                });

                                if (error == false) {
                                    modal.dismiss('newVersionFile');
                                    $scope.FormSent = false;
                                }
                            } else $scope.FileCount--;
                        }
                        $scope.UploadingFile = false;
                    }
                    else {
                        $scope.Error = '';
                        angular.forEach($scope.AddNewVersionFile.Files, function (file) {
                            if (file.Error != undefined && file.Error != '') {
                                error = true;
                                $scope.Error += file.Error + '<br/>';
                            }
                        });
                    }

                    loadVersionFiles($scope, bll);
                },
                OpenEditVersionFileModal: function ($scope, modal, file) {
                    if (modal.open('editVersionFile', 'inviteColleagueModal')) {
                        $scope.editVersionFile = {};
                        angular.copy(file, $scope.editVersionFile);
                        $scope.editVersionFile.CompanyID = $scope.application.CompanyID;
                    }
                },
                SaveEditVersionFile: function ($scope, modal, bll) {
                    bll.UpdateVersionFile(function (data) {
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        } else {
                            loadVersionFiles($scope, bll);
                            modal.dismiss('editVersionFile');
                            DialogHandler.AddMessage('Version file updated!');
                        }
                    }, $scope.editVersionFile);
                },
                ConfirmVersionFileDelete: function ($scope, modal, bll, file) {
                    if (modal.open('DeleteVersionFileConfirm', 'inviteColleagueModal', null, { rejectedCallback: function () { deleteFileID = undefined; } })) {
                        deleteFileID = file.FileID;
                        bll.CheckAppVersionFile(function (data) {
                            if (data.content == true) {
                                $scope.DeleteVersionFileMessage = 'File is not used by any other version and will be permanently deleted!';
                            }
                            if (data.content == false) {
                                $scope.DeleteVersionFileMessage = 'File is used by other versions and will be removed only from this version!';
                            }
                        }, file.FileID);
                    }
                },
                DeleteVersionFile: function ($scope, modal, bll) {
                    bll.DeleteVersionFile(function (data) {
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        } else {
                            loadVersionFiles($scope, bll);
                            modal.dismiss('DeleteVersionFileConfirm');
                            DialogHandler.AddMessage('File deleted!');
                        }
                    }, deleteFileID, $scope.application.ApplicationVersionID);
                },
                GetExistingVersionFiles: function ($scope, bll) {
                    bll.GetExistingVersionFiles(function (data) {
                        $scope.ExistingFilesRecieved = true;
                        if (data.hasError || data.error != undefined) {
                            DialogHandler.AddError(data.error);
                        } else {
                            $scope.ExistingFileList = data.content;
                            if ($scope.ExistingFileList.length > 0) $scope.ExistingVersionFiles.TotalCount = $scope.ExistingFileList[0].TotalCount;
                            else $scope.ExistingVersionFiles.TotalCount = 0;
                            angular.forEach($scope.ExistingFileList, function (file) {
                                file.checked = false;
                            });
                            if ($scope.ExistingFileList.length > 0 && AddSelectedFiles.ApplicationVersionFileList.length > 0) {
                                angular.forEach($scope.ExistingFileList, function (file) {
                                    angular.forEach(AddSelectedFiles.ApplicationVersionFileList, function (sfile) {
                                        if (file.FileID == sfile.FileID) file.checked = true;
                                    });
                                });
                            }
                        }
                    }, $scope.ExistingVersionFiles);
                },
                ChangeExistingFilePage: function ($scope, bll) {
                    $scope.ExistingVersionFiles.Offset = ($scope.vfPager.CurrentPage - 1) * $scope.vfPager.ItemsPerPage;
                    this.GetExistingVersionFiles($scope, bll);
                },
                OpenExistingVersionFileModal: function ($scope, modal, bll) {
                    if (modal.open('AddExistingVersionFiles', 'inviteColleagueModal')) {
                        $scope.ExistingFilesRecieved = false;
                        $scope.ExistingVersionFiles = {};
                        $scope.ExistingVersionFiles.VersionID = $scope.application.ApplicationVersionID;
                        $scope.ExistingVersionFiles.companyID = $scope.application.CompanyID;
                        $scope.ExistingVersionFiles.Text = '';
                        $scope.ExistingVersionFiles.Offset = 0;
                        $scope.ExistingVersionFiles.Count = 5;
                        AddSelectedFiles = {};
                        AddSelectedFiles.ApplicationVersionFileList = [];
                        this.GetExistingVersionFiles($scope, bll);
                    }
                },
                SelectExistingFile: function ($scope, file) {
                    if (file.checked) {
                        var object = {};
                        object.FileID = file.FileID;
                        object.ApplicationVersionID = $scope.application.ApplicationVersionID;
                        AddSelectedFiles.ApplicationVersionFileList.push(object);
                    }
                    else if (!file.checked) {
                        var index = -1;
                        angular.forEach(AddSelectedFiles.ApplicationVersionFileList, function (addedFile, key) {
                            if (addedFile.FileID == file.FileID) index = key;
                        });
                        if (index != -1) {
                            AddSelectedFiles.ApplicationVersionFileList.splice(index, 1);
                        }
                    }
                },
                ResetFileSelection: function ($scope) {
                    AddSelectedFiles = {};
                    AddSelectedFiles.ApplicationVersionFileList = [];
                    angular.forEach($scope.ExistingFileList, function (file) {
                        file.checked = false;
                    });
                },
                AddSelectedFilesToVersion: function ($scope, bll, modal) {
                    if (AddSelectedFiles.ApplicationVersionFileList.length == 0) {
                        DialogHandler.AddError('No files selected!');
                        return;
                    }
                    bll.AddExistingVersionFiles(function (data) {
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        } else {
                            loadVersionFiles($scope, bll);
                            modal.dismiss('AddExistingVersionFiles');
                            DialogHandler.AddMessage('File(s) added!');
                        }
                    }, AddSelectedFiles)
                },
                SetFileDestination: function ($scope, type, index) {
                    switch (type) {
                        case 'application':
                            $scope.AddNewVersionFile.Files[index].Destination = 'Applications' + ($filter('IsArchive')($scope.AddNewVersionFile.Files[index].FileName) ? '' : '\\' + $scope.AddNewVersionFile.Files[index].FileName);
                            break;
                        case 'fixed':
                            $scope.AddNewVersionFile.Files[index].Destination = 'FixedFiles' + ($filter('IsArchive')($scope.AddNewVersionFile.Files[index].FileName) ? '' : '\\' + $scope.AddNewVersionFile.Files[index].FileName);
                            break;
                        case 'plain':
                            $scope.AddNewVersionFile.Files[index].Destination = ($filter('IsArchive')($scope.AddNewVersionFile.Files[index].FileName) ? '\\' : $scope.AddNewVersionFile.Files[index].FileName);
                            break;
                        default: break;
                    }
                },//VersionFiles end
                //Executable actions
                OpenExeActionModal: function ($scope, modal, exeAction) {
                    if (modal.open('ExeActions', 'inviteColleagueModal')) {
                        $scope.ExeAction = {};
                        $scope.ExeAction.ApplicationVersionID = $scope.application.ApplicationVersionID
                        if (exeAction != undefined) {
                            $scope.isNewExeAction = false;
                            $scope.ExeAction.Stage = exeAction.Stage;
                            $scope.ExeAction.Action = exeAction.Action;
                            $scope.ExeAction.Order = exeAction.Order;
                            $scope.ExeAction.Arguments = exeAction.Arguments;
                            $scope.ExeAction.ApplicationVersionExecutableActionID = exeAction.ApplicationVersionExecutableActionID;
                            $scope.ExeAction.StartStyle = exeAction.StartStyle.toString();
                            $scope.ExeAction.WaitForExit = exeAction.WaitForExit;
                        }
                        else $scope.isNewExeAction = true;
                        $scope.FormSent = false;
                    }
                },
                CreateExeAction: function ($scope, bll, modal) {
                    if ($scope.forms.exeActionsForm.$valid) {
                        bll.AddExecutableAction(function (data) {
                            if (data.hasError) {
                                DialogHandler.AddError(data.error);
                            } else {
                                loadExeActions($scope, bll);
                                modal.dismiss('ExeActions');
                                DialogHandler.AddMessage('Executable Action created!');
                            }
                        }, $scope.ExeAction);
                    }
                },
                UpdateExeAction: function ($scope, bll, modal) {
                    if ($scope.forms.exeActionsForm.$valid) {
                        bll.updateExecutableAction(function (data) {
                            if (data.hasError) {
                                DialogHandler.AddError(data.error);
                            } else {
                                loadExeActions($scope, bll);
                                modal.dismiss('ExeActions');
                                DialogHandler.AddMessage('Executable Action updated!');
                            }
                        }, $scope.ExeAction);
                    }
                },
                ConfirmExeActionDelete: function (ExeAction, modal) {
                    if (modal.open('ExeActionDeleteConfirm', 'inviteColleagueModal', null, { rejectedCallback: function () { deleteExeActionID = undefined; } }))
                        deleteExeActionID = ExeAction.ApplicationVersionExecutableActionID;
                },
                DeleteExeAction: function ($scope, bll, modal) {
                    bll.deleteExecutableAction(function (data) {
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        } else {
                            loadExeActions($scope, bll);
                            modal.dismiss('ExeActionDeleteConfirm');
                            DialogHandler.AddMessage('Executable Action deleted!');
                        }
                    }, deleteExeActionID);
                },//Executable actions end
                //Requirements
                AddRequirementModal: function ($scope, bll, modal) {
                    if (modal.open('appRequirements', 'inviteColleagueModal')) {
                        $scope.requirementForm = {};
                        bll.getRequirementTypes(function (data) {
                            $scope.reqTypes = data;
                        });
                    }
                },
                RemoveRequirement: function ($scope, requirement, newIndex) {
                    if (requirement.HardwareRequirementID != undefined) {
                        var index = -1;
                        for (var i = 0; i < $scope.appReqs.length; i++) {
                            if (requirement.HardwareRequirementID == $scope.appReqs[i].HardwareRequirementID) {
                                index = i;
                                removeReqList.push(requirement.HardwareRequirementID);
                                break;
                            }
                        }
                        if (index != -1) {
                            $scope.appReqs.splice(index, 1);
                        }
                    }
                    else {
                        $scope.addReqList.splice(newIndex, 1);
                    }
                },
                AddNewRequirement: function ($scope, modal) {
                    if ($scope.forms.editReqForm.$valid && !$scope.FormSent) {
                        $scope.FormSent = true;
                        if (typeof $scope.requirementForm.RequirementType == 'object') {
                            $scope.requirementForm.TypeName = $scope.requirementForm.RequirementType.ComponentName;
                            $scope.requirementForm.RequirementType = $scope.requirementForm.RequirementType.PCComponentTypeID;
                        }

                        $scope.addReqList.push($scope.requirementForm);
                        modal.dismiss('appRequirements');
                        $scope.FormSent = false;
                    }
                },
                SaveRequirementChanges: function (dev, $scope, bll, formHelper) {
                    if (!$scope.noChangeAllowed) {
                        var ReqObject = {};
                        $scope.reqSave = true;
                        ReqObject.addList = $scope.addReqList;
                        ReqObject.removeList = removeReqList;
                        ReqObject.VersionID = $scope.application.ApplicationVersionID;
                        bll.addRemoveRequirements(function (data) {
                            $scope.reqSave = false;
                            if (data.hasError) {
                                DialogHandler.AddError(data.error);
                            } else {
                                DialogHandler.AddMessage('Changes saved!');
                                reloadVersion(dev, $scope, bll, formHelper);
                            }
                        }, ReqObject);
                    }
                },//Requirements end
                //Config blocks
                OpenConfigBlockModal: function ($scope, modal, block, isGroup, group) {
                    if (modal.open('ConfiguratorBlock', 'inviteColleagueModal')) {
                        var groupBlocks;
                        $scope.BlockTabs = { Active: 'Block' };
                        $scope.dataSent = false;

                        $scope.configBlock = {};
                        $scope.configBlock.Settings = {};
                        $scope.configBlock.ApplicationVersionID = $scope.application.ApplicationVersionID;
                        if (isGroup == undefined) {
                            if (block != undefined) {
                                $scope.isNewConfigBlock = false;
                                $scope.configBlock = angular.copy(block);
                                $scope.configBlock.CodeNew = $scope.configBlock.Code;
                                if ($scope.configBlock.OptionsString == undefined) {
                                    $scope.configBlock.OptionsString = block.Options == null ? 'N/A' : block.Options == 'null' ? 'N/A' : typeof block.Options == 'string' ? block.Options : angular.toJson(block.Options);
                                }

                                $scope.configBlock.ValidationParameters = block.ValidationParameters == null ? 'N/A' : typeof block.ValidationParameters == 'string' ? block.ValidationParameters : JSON.stringify(block.ValidationParameters);
                                var settings
                                if (block.Settings == null || block.Settings == 'N/A') {
                                    settings = ConfigBlockHelper.getExtraSettings(block.BlockName);
                                }
                                else settings = $scope.configBlock.Settings;
                                if (block.Interactions == undefined || block.GridDatao == undefined) {
                                    $scope.configBlock.Settings = settings;
                                    var settingsObj = JSON.parse($scope.configBlock.Settings);
                                    if ($scope.configBlock.Interactions == undefined)
                                        $scope.configBlock.Interactions = settingsObj.Interaction == 'N/A' ? 'N/A' : JSON.stringify(settingsObj.Interaction);

                                    if ($scope.configBlock.GridDatao == undefined)
                                        $scope.configBlock.GridDatao = JSON.parse(ConfigBlockHelper.getGridData(block.BlockName));
                                }
                                if (typeof $scope.configBlock.Interactions != 'string') $scope.configBlock.Interactions = JSON.stringify($scope.configBlock.Interactions);
                                $scope.newGroup = false;
                            }
                            else {
                                $scope.isNewConfigBlock = true;
                                $scope.newGroup = false;
                                $scope.configBlock.IsAdvanced = false;
                                if (group != undefined) {
                                    $scope.configBlock.GroupName = group;
                                    groupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: group }, true);
                                    if (groupBlocks.length == 1)
                                        $scope.configBlock.IsAdvanced = groupBlocks[0].IsAdvanced;
                                }
                            }
                        }
                        else {
                            if (isGroup == true) {
                                $scope.newGroup = true;
                                $scope.configBlock.IsAdvanced = false;
                            }
                            else $scope.newGroup = false;

                            if (block != undefined) {
                                $scope.configBlock.GroupName = block.GroupName;
                            }
                            if (group != undefined) {
                                $scope.isNewConfigBlock = false;
                                $scope.configBlock.GroupName = group;
                                $scope.configBlock.renameGroup = group;
                                groupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: group }, true);
                                if (groupBlocks.length == 1)
                                    $scope.configBlock.IsAdvanced = groupBlocks[0].IsAdvanced;
                                else if (groupBlocks.length > 1) {
                                    var isAdv = true;
                                    angular.forEach(groupBlocks, function (block) {
                                        if (!block.IsAdvanced) isAdv = false;
                                    });
                                    $scope.configBlock.IsAdvanced = isAdv;
                                }
                            }
                            else $scope.isNewConfigBlock = true;
                        }
                    }
                },
                MoveGroup: function ($scope, direction, group) {
                    var groupList = [];
                    angular.forEach($scope.groupList, function (grName) {
                        var groupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: grName }, true);
                        groupList.push(groupBlocks);
                    });
                    groupList.sort(function (a, b) {
                        return a[0].GroupOrder > b[0].GroupOrder ? 1 : -1;
                    });
                    var index = -1;
                    angular.forEach(groupList, function (groupbl, key) {
                        if (groupbl[0].GroupName == group) index = key;
                    });
                    if (direction == 0) {
                        if (index == 0) return;
                        angular.forEach(groupList[index], function (block) {
                            block.GroupOrder -= 100;
                        });
                        angular.forEach(groupList[index - 1], function (block) {
                            block.GroupOrder += 100;
                        });
                        loadConfiguration($scope, true, true);
                    }
                    else {
                        if (index == groupList.length - 1) return;
                        angular.forEach(groupList[index], function (block) {
                            block.GroupOrder += 100;
                        });
                        angular.forEach(groupList[index + 1], function (block) {
                            block.GroupOrder -= 100;
                        });
                        loadConfiguration($scope, true, true);
                    }

                    scrollToConfigGroup(group);
                },
                SaveConfigurationBlocks: function ($scope, bll, modal) {
                    if ($scope.processing) return;
                    $scope.processing = true;
                    $scope.ConfiguratorSaving = true;
                    try {
                        angular.forEach($scope.Configurator.ConfigBlocks, function (block) {
                            block.GridData = JSON.stringify(block.GridDatao);
                            if (block.OptionsString != undefined)
                                block.OptionsString = block.OptionsString == 'N/A' ? null : typeof block.OptionsString == 'string' ? block.OptionsString : angular.toJson(block.OptionsString);
                            else block.OptionsString = block.Options == 'N/A' ? null : typeof block.Options == 'string' ? block.Options : angular.toJson(block.Options);
                        });
                    }
                    catch (e) {
                        void 0;
                        $scope.processing = false;
                        $scope.ConfiguratorSaving = false;
                        DialogHandler.AddError('Error occurred while collecting data!');
                        return;
                    }

                    bll.saveConfiguratorBlocks(function (data) {
                        $scope.ConfiguratorSaving = false;
                        $scope.processing = false;
                        if (data.hasError) {
                            DialogHandler.AddError('Error occurred while saving!');
                        }
                        else {
                            $scope.Configurator.ConfigBlocks = [];
                            modal.dismiss('ConfiguratorBlockDelete')
                            loadBlocks($scope, true, true);
                            DialogHandler.AddMessage('Configuration saved!');
                        }
                    }, { blocks: $scope.Configurator.ConfigBlocks, removeBlocks: deleteBlockList });
                },
				ConfirmConfigSave: confirmconfigSave,
                AddBlockGroup: function ($scope, modal) {
                    if ($scope.forms.configForm.$valid) {
                        $scope.dataSent = true;
                        var index = $scope.groupList.indexOf($scope.configBlock.GroupName);
                        if (index == -1) {
                            if ($scope.Configurator.ConfigBlocks.length == 0) {
                                $scope.configBlock.GroupOrder = 101;
                            }
                            else {
                                var lastGroup = $scope.Configurator.ConfigBlocks[$scope.Configurator.ConfigBlocks.length - 1].GroupName;
                                var filter = $filter('filter')($scope.Configurator.ConfigBlocks, {
                                    GroupName: lastGroup
                                }, true);
                                if (filter.length != 0) {
                                    $scope.configBlock.GroupOrder = filter[0].GroupOrder + 100;
                                }
                            }

                            $scope.groupList.push($scope.configBlock.GroupName);
                            $scope.Configurator.ConfigBlocks.push($scope.configBlock);
                            loadConfiguration($scope, true);
                            modal.dismiss('ConfiguratorBlock');
                            triggerConfigChange($scope);

                            scrollToConfigGroup($scope.configBlock.GroupName);
                        }
                        else DialogHandler.AddError('Group already exists!');

                        $scope.dataSent = false;
                    }
                },
                SwitchBlockTab: function ($scope, tab) {
                    $scope.BlockTabs.Active = tab;
                },
                RenameBlockGroup: function ($scope, modal) {
                    if ($scope.forms.configForm.$valid) {
                        var equalName = false;
                        if ($scope.configBlock.GroupName == $scope.configBlock.renameGroup) {
                            equalName = true;
                        }
                        if (!equalName) {
                            if ($scope.groupList.indexOf($scope.configBlock.GroupName) != -1) {
                                DialogHandler.AddError('Group name already exists!');
                                return;
                            }
                        }

                        var rename = $filter('filter')($scope.Configurator.ConfigBlocks, {
                            GroupName: $scope.configBlock.renameGroup
                        }, true);
                        angular.forEach(rename, function (block) {
                            if (!equalName) block.GroupName = $scope.configBlock.GroupName;
                            block.IsAdvanced = $scope.configBlock.IsAdvanced;
                        });
                        var index = $scope.groupList.indexOf($scope.configBlock.renameGroup);
                        if (index != -1) $scope.groupList[index] = $scope.configBlock.GroupName;
                        triggerConfigChange($scope);
                        modal.dismiss('ConfiguratorBlock');
                    }
                },
                OpenAddInteraction: function ($scope, modal, configBlock) {
                    if (modal.open('CBInteractions', 'inviteColleagueModal', 'static')) {
                        $scope.BlockInteraction = {};
                        $scope.blockCodes = [];
                        $scope.conditionInput = false;
                        try {
                            $scope.ChooseSettingList = configBlock.Interactions == undefined ? [] : JSON.parse(configBlock.Interactions);
                        }
                        catch (error) {
                            DialogHandler.AddError('Invalid settings detected, review settings!');
                        }
                    }
                },
                GetBlocks: function ($scope) {//for interaction
                    angular.forEach($scope.blockList, function (bl) {
                        if ($scope.configBlock.Code != bl.Code) $scope.blockCodes.push(bl.Code);
                    });
                },
                ShowConditionInput: function ($scope) {
                    $scope.conditionInput = true;
                    $scope.BlockInteraction.Condition = '';

                    if ($scope.configBlock.BlockName == blockType.positioning || $scope.configBlock.BlockName == blockType.region) {
                        //positioning(LOGO) background
                        if ($scope.BlockInteraction.SettingName == 'landscape') {
                            $scope.BlockInteraction.placeholder = '=valueOfLandscapeOrientation';
                        }
                        else if ($scope.BlockInteraction.SettingName == 'ratio169') {
                            $scope.BlockInteraction.placeholder = '=valueOf16:9ratio';
                        }
                        else $scope.BlockInteraction.placeholder = '=';
                    }
                },
                ConfirmExtraSettings: function ($scope, modal) {
                    var Settings;
                    //positioning(LOGO) background
                    if ($scope.configBlock.BlockName == blockType.positioning || $scope.configBlock.BlockName == blockType.region) {
                        switch ($scope.BlockInteraction.SettingName) {
                            case 'landscape':
                            case 'ratio169':
                                if ($scope.BlockInteraction.SettingName == 'landscape' && $scope.BlockInteraction.Condition == '=valueOfLandscapeOrientation') {
                                    DialogHandler.AddError('Value not entered!');
                                    return;
                                }
                                if ($scope.BlockInteraction.SettingName == 'ratio169' && $scope.BlockInteraction.Condition == '=valueOf16:9ratio') {
                                    DialogHandler.AddError('Value not entered!');
                                    return;
                                }
                                if ($scope.BlockInteraction.Condition.indexOf('=') == -1) {
                                    DialogHandler.AddError('Operator missing');
                                    return;
                                }
                                Settings = JSON.parse($scope.configBlock.Interactions);
                                Settings[$scope.BlockInteraction.SettingName] = $scope.BlockInteraction.Block + $scope.BlockInteraction.Condition;
                                $scope.configBlock.Interactions = JSON.stringify(Settings);
                                modal.close('CBInteractions');
                                break;
                            case 'areaBackground':
                            case 'areaBackgroundPosition':
                                Settings = JSON.parse($scope.configBlock.Interactions);
                                if ($scope.BlockInteraction.Condition.trim() == '=') {
                                    Settings[$scope.BlockInteraction.SettingName] = $scope.BlockInteraction.Block;
                                    $scope.configBlock.Interactions = JSON.stringify(Settings);
                                    modal.close('CBInteractions');
                                }
                                else DialogHandler.AddError('Input not valid!');

                                break;
                            default:
                                break;
                        }
                    }
                },
                UpdateBlock: function ($scope, modal) {
                    if ($scope.forms.configForm.$valid) {
                        $scope.dataSent = true;

                        try {
                            if ($scope.configBlock.CodeNew != $scope.configBlock.Code) {
                                var getBlockByCode = $filter('filter')($scope.Configurator.ConfigBlocks, { Code: $scope.configBlock.CodeNew }, true);
                                if (getBlockByCode.length > 0) {
                                    DialogHandler.AddError('Name in config already exists!');
                                    $scope.dataSent = false;
                                    return;
                                }
                            }

                            //try to parse first
                            var validOptions = $scope.configBlock.OptionsString == 'N/A' ? null : JSON.parse($scope.configBlock.OptionsString);
                            var validDefault = $scope.configBlock.BlockName == blockType.hidden ? $scope.configBlock.DefaultValue : JSON.parse($scope.configBlock.DefaultValue);
                            var validInteraction = $scope.configBlock.Interactions == 'N/A' ? 'N/A' : JSON.parse($scope.configBlock.Interactions);

                            var index = -1;
                            var groupChange = false;
                            var prevGroup, groupPlaceholder, prevGoupOrder;
                            angular.forEach($scope.Configurator.ConfigBlocks, function (block, key) {
                                if (block.Code == $scope.configBlock.Code || (block.BlockID != undefined && block.BlockID == $scope.configBlock.BlockID)) {
                                    index = key;
                                    $scope.configBlock.Code = $scope.configBlock.CodeNew;
                                    if (block.GroupName != $scope.configBlock.GroupName) {
                                        groupChange = true;
                                        prevGroup = block.GroupName;
                                        prevGoupOrder = block.GroupOrder;
                                    }
                                }
                            });
                            var settingObj = JSON.parse($scope.configBlock.Settings);

                            if (groupChange) {
                                var groupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: $scope.configBlock.GroupName }, true);
                                if (groupBlocks.length == 0) {
                                    DialogHandler.AddError('Error in group data!');
                                    return;
                                }
                                if (groupBlocks.length == 1 && groupBlocks[0].Code == undefined) {
                                    $scope.configBlock.GroupOrder = groupBlocks[0].GroupOrder;
                                    $scope.configBlock.GridDatao.row = 0;
                                    $scope.configBlock.GridDatao.col = 0;
                                }
                                else {
                                    var order = $filter('orderBy')(groupBlocks, 'GridDatao.row');

                                    if (order[order.length - 1].GridDatao.sizeX == 3 && $scope.configBlock.GridDatao.sizeX == 3 && order[order.length - 1].GridDatao.col == 0) {
                                        $scope.configBlock.GridDatao.row = order[order.length - 1].GridDatao.row;
                                        $scope.configBlock.GridDatao.col = 3;
                                    }
                                    else {
                                        $scope.configBlock.GridDatao.row = order[order.length - 1].GridDatao.row + order[order.length - 1].GridDatao.sizeY;
                                        $scope.configBlock.GridDatao.col = 0;
                                    }

                                    var oldGroupOrder = $scope.configBlock.GroupOrder;
                                    if (prevGroup != undefined) {
                                        var oldGroupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: prevGroup }, true);
                                        if (oldGroupBlocks.length == 1) {
                                            groupPlaceholder = {};
                                            groupPlaceholder.GroupOrder = oldGroupOrder;
                                            groupPlaceholder.GroupName = prevGroup;
                                        }
                                    }

                                    $scope.configBlock.GroupOrder = order[order.length - 1].GroupOrder;
                                }
                            }
                            $scope.configBlock.Interaction = validInteraction;
                            $scope.configBlock.Options = validOptions;
                            $scope.configBlock.ValidationParameters = $scope.configBlock.ValidationParameters == 'N/A' ? null : $scope.configBlock.ValidationParameters;
                            $scope.configBlock.ConfigurationValue = validDefault;

                            settingObj.Interaction = $scope.configBlock.Interaction;
                            $scope.configBlock.Settings = JSON.stringify(settingObj);
                            $scope.configBlock.GridData = JSON.stringify($scope.configBlock.GridDatao)

                            if (index != -1) {
                                $scope.Configurator.ConfigBlocks.splice(index, 1, $scope.configBlock);
                                if (groupPlaceholder != undefined) $scope.Configurator.ConfigBlocks.push(groupPlaceholder);

                                //prew group will be removed if it's empty, need it back
                                var prewgroupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: prevGroup }, true);
                                if (prewgroupBlocks.length == 0) {

                                    var newEmptyGroupBlock = $filter('filter')($scope.Configurator.ConfigBlocks,
                                        function (value) {
                                            return value.GroupName == $scope.configBlock.GroupName && typeof value.BlockName == 'undefined';
                                        }, true);
                                    angular.forEach(newEmptyGroupBlock, function (v) {
                                        if (typeof v.BlockName == 'undefined') {
                                            v.GroupName = prevGroup;
                                            v.GroupOrder = prevGoupOrder;
                                        }
                                    });
                                }

                                $scope.Configurator.ConfigBlocks = $filter('orderBy')($scope.Configurator.ConfigBlocks, 'GroupOrder');

                                triggerConfigChange($scope);
                                modal.dismiss('ConfiguratorBlock');
                            }
                            else {
                                DialogHandler.AddError('Could not update block!');
                                $scope.dataSent = false;
                            }
                        }
                        catch (e) {
                            $scope.configBlock.ValidationParameters = $scope.configBlock.ValidationParameters == null ? 'N/A' : $scope.configBlock.ValidationParameters;
                            void 0;
                            $scope.dataSent = false;
                            DialogHandler.AddError('Could not interpret some of values!');
                        }
                    }
                },
                CreateBlock: function ($scope, modal) {
                    if ($scope.forms.configForm.$valid) {
                        $scope.dataSent = true;
                        try {
                            var getBlockByCode = $filter('filter')($scope.Configurator.ConfigBlocks, { Code: $scope.configBlock.CodeNew }, true);
                            if (getBlockByCode.length > 0) {
                                DialogHandler.AddError('Name in config already exists!');
                                $scope.dataSent = false;
                                return;
                            }

                            var validOptions = $scope.configBlock.OptionsString == 'N/A' ? null : JSON.parse($scope.configBlock.OptionsString);
                            var validDefault = $scope.configBlock.BlockName == blockType.hidden ? $scope.configBlock.DefaultValue : JSON.parse($scope.configBlock.DefaultValue);
                            $scope.configBlock.GridDatao = JSON.parse($scope.configBlock.GridData);

                            //Configurator.ConfigBlocks
                            var groupBlocks = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: $scope.configBlock.GroupName }, true);
                            if (groupBlocks.length == 1 && groupBlocks[0].Code == undefined) {
                                $scope.configBlock.GroupOrder = groupBlocks[0].GroupOrder;
                                var removeIndex = $scope.Configurator.ConfigBlocks.indexOf(groupBlocks[0]);
                                $scope.Configurator.ConfigBlocks.splice(removeIndex, 1);
                            }
                            else {
                                var order = $filter('orderBy')(groupBlocks, 'GridDatao.row');
                                if (order.length > 0) {
                                    if (order[order.length - 1].GridDatao.sizeX == 3 && $scope.configBlock.GridDatao.sizeX == 3 && order[order.length - 1].GridDatao.col == 0) {
                                        $scope.configBlock.GridDatao.row = order[order.length - 1].GridDatao.row;
                                        $scope.configBlock.GridDatao.col = 3;
                                    }
                                    else {
                                        $scope.configBlock.GridDatao.row = order[order.length - 1].GridDatao.row + order[order.length - 1].GridDatao.sizeY;
                                        $scope.configBlock.GridDatao.col = 0;
                                    }
                                }
                                else {
                                    $scope.configBlock.GridDatao.row = 0;
                                    $scope.configBlock.GridDatao.col = 0;
                                }

                                $scope.configBlock.GroupOrder = order[order.length - 1].GroupOrder;
                            }
                            $scope.configBlock.Options = validOptions;
                            $scope.configBlock.ValidationParameters = $scope.configBlock.ValidationParameters == 'N/A' ? null : $scope.configBlock.ValidationParameters;
                            $scope.configBlock.ConfigurationValue = validDefault;
                            $scope.configBlock.Code = $scope.configBlock.CodeNew;
                            $scope.Configurator.ConfigBlocks.push($scope.configBlock);
                            $scope.Configurator.ConfigBlocks = $filter('orderBy')($scope.Configurator.ConfigBlocks, 'GroupOrder');
                            triggerConfigChange($scope);
                            modal.dismiss('ConfiguratorBlock');
                            DialogHandler.AddMessage('Block added!');
                        }
                        catch (e) {
                            $scope.configBlock.ValidationParameters = $scope.configBlock.ValidationParameters == null ? 'N/A' : $scope.configBlock.ValidationParameters;

                            void 0;
                            $scope.dataSent = false;
                            DialogHandler.AddError('Could not interpret some of values!');
                        }
                    }
                },
                ConfirmBlockDelete: function ($scope, modal, block, group) {
                    if (modal.open('ConfiguratorBlockDelete', 'inviteColleagueModal', null, { rejectedCallback: function () { deleteBlockID = undefined, groupDelete = undefined; } })) {
                        $scope.blockDelete = 0;
                        if (block != undefined) {
                            if (block.BlockID != undefined) deleteBlockID = block.BlockID;
                            else deleteBlockID = block.Code;
                        }
                        else if (group != undefined) {
                            $scope.blockDelete = 1;
                            groupDelete = group;
                        }
                        else return;
                    }
                },
                DeleteBlock: function ($scope, modal) {
                    $scope.processing = true;
                    if (typeof deleteBlockID == 'number') deleteBlockList.push(deleteBlockID);
                    var index = -1;
                    angular.forEach($scope.Configurator.ConfigBlocks, function (block, key) {
                        if (typeof deleteBlockID == 'string') {
                            if (block.Code == deleteBlockID) index = key;//was BlockID
                        }
                        else {
                            if (block.BlockID == deleteBlockID) index = key;
                        }
                    });
                    if (index != -1) {
                        var GroupPlaceHolder = {};
                        var filter = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: $scope.Configurator.ConfigBlocks[index].GroupName }, true);
                        var flength = filter.length;
                        if (flength == 1) {
                            GroupPlaceHolder.GroupName = $scope.Configurator.ConfigBlocks[index].GroupName;
                            GroupPlaceHolder.GroupOrder = $scope.Configurator.ConfigBlocks[index].GroupOrder;
                            GroupPlaceHolder.ApplicationVersionID = $scope.Configurator.ConfigBlocks[index].ApplicationVersionID
                        }

                        $scope.Configurator.ConfigBlocks.splice(index, 1);
                        if (flength == 1) {
                            $scope.Configurator.ConfigBlocks.push(GroupPlaceHolder);
                            $scope.Configurator.ConfigBlocks = $filter('orderBy')($scope.Configurator.ConfigBlocks, 'GroupOrder');
                        }

                        triggerConfigChange($scope);
                        modal.dismiss('ConfiguratorBlockDelete');
                    }
                    else DialogHandler.AddError('Error occurred while removing block!');
                    $scope.processing = false;
                },
                DeleteGroup: function ($scope, modal) {
                    if (groupDelete == undefined) {
                        DialogHandler.AddError('Error occurred while removing group!');
                        return;
                    }
                    $scope.processing = true;
                    var filter = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: groupDelete }, true);

                    angular.forEach(filter, function (block) {
                        if (block.BlockID != undefined) deleteBlockList.push(block.BlockID);
                    });

                    var groupList = [];
                    angular.forEach($scope.groupList, function (gr) {
                        var filter = $filter('filter')($scope.Configurator.ConfigBlocks, { GroupName: gr }, true);
                        groupList.push(filter);
                    });
                    groupList.sort(function (a, b) {
                        return a[0].GroupOrder > b[0].GroupOrder ? 1 : -1;
                    });
                    var groupIndex = -1;
                    angular.forEach(groupList, function (gr, key) {
                        if (gr[0].GroupName == groupDelete) groupIndex = key;
                    });

                    if (groupIndex != 0 && groupIndex != groupList.length - 1) {
                        for (let i = groupIndex + 1; i < groupList.length; i++) {
                            angular.forEach(groupList[i], function (bl) {
                                bl.GroupOrder -= 100;
                            });
                        }
                    }

                    let i = $scope.Configurator.ConfigBlocks.length
                    while (i--) {
                        if ($scope.Configurator.ConfigBlocks[i].GroupName == groupDelete) {
                            $scope.Configurator.ConfigBlocks.splice(i, 1);
                        }
                    }
                    var grIndex = $scope.groupList.indexOf(groupDelete);
                    if (grIndex != -1) $scope.groupList.splice(grIndex, 1);

                    triggerConfigChange($scope);
                    modal.dismiss('ConfiguratorBlockDelete');
                    $scope.processing = false;
                },//Config Block end
                //Import/export
                OpenExport: function ($scope, modal, bll, copy) {
                    if (modal.open('ExportSettings', 'inviteColleagueModal', 'static')) {
                        versionCopy = false;
                        resetExportValues($scope);
                        if (copy) {
                            $scope.appVersionList = [];
                            $scope.AppList = [];
                            getAppList($scope, bll);
                            $scope.CopyAppInfo = {};
                            $scope.ExportImportMode = 4;
                        }
                        else {
                            getExportData($scope, bll, $scope.application.ApplicationVersionID, $scope.application.ApplicationID, copy);
                            $scope.ExportImportMode = 0;
                        }
                        resetExportArrayValues($scope);
                    }
                },
                CopyVersion: function ($scope, bll) {
                    versionCopy = true;
                    resetExportValues($scope);
                    getExportData($scope, bll, $scope.importfromver.ver.ApplicationVersionID, $scope.application.ApplicationID, false, true);
                    $scope.ExportImportMode = 5;
                    resetExportArrayValues($scope);
                },
                OpenImport: function ($scope, modal) {
                    if (modal.open('ExportSettings', 'inviteColleagueModal', 'static')) {
                        $scope.ExportImportMode = 1;
                        $scope.Importloading = false;
                        $scope.iFile = '';
                        $scope.ImportError = '';
                        $scope.Importloading = false;
                        $scope.ExportError = '';
                        $scope.importfromver = {};
                        versionCopy = false;
                    }
                },
                ToggleSelection: function ($scope, opt, target, event) {
                    var idx = target.indexOf(opt);
                    if (idx > -1) {
                        target.splice(idx, 1);
                        switch (opt) {
                            case 1:
                                $scope.ExportFileSelection = [];
                                break;
                            case 2:
                                $scope.ExportActSelection = [];
                                break;
                            case 3:
                                $scope.ExportReqSelection = [];
                                break;
                            case 4:
                                $scope.ExportImgSelection = [];
                                break;
                            case 5:
                                $scope.ExportBlockSelection = [];
                                break;
                            default:
                        }
                    }
                    else {
                        target.push(opt);
                        switch (opt) {
                            case 1:
                                angular.forEach($scope.versionFilesList, function (verFile) {
                                    $scope.ExportFileSelection.push(verFile.FileID);
                                });
                                break;
                            case 2:
                                angular.forEach($scope.exeActionsList, function (exeAct) {
                                    $scope.ExportActSelection.push(exeAct.ApplicationVersionExecutableActionID);
                                });
                                break;
                            case 3:
                                angular.forEach($scope.appRequirements, function (reqs) {
                                    $scope.ExportReqSelection.push(reqs.HardwareRequirementID);
                                });
                                break;
                            case 4:
                                angular.forEach($scope.application.AttchedAssetFiles, function (file) {
                                    $scope.ExportImgSelection.push(file.MediaAssetID);
                                });
                                break;
                            case 5:
                                angular.forEach($scope.blocksList, function (block) {
                                    $scope.ExportBlockSelection.push(block.BlockID);
                                });
                                break;
                            default:
                        }
                    }
                    angular.forEach($scope.exportOptions, function (option) {
                        if (option.value == opt) option.indeterminate = false;
                    });
                    $scope.ExportError = '';
                    if (event != undefined)
                        event.stopPropagation();
                },
                ToggleAnySelection: function ($scope, opt, target, parent, data, cat) {
                    var idx = target.indexOf(opt);
                    if (idx > -1) {
                        target.splice(idx, 1);
                        idx = parent.indexOf(cat);
                        if (idx > -1) {
                            parent.splice(idx, 1);
                            if (target.length != 0) {
                                angular.forEach($scope.exportOptions, function (option) {
                                    if (option.value == cat) option.indeterminate = true;
                                });
                            }
                        }
                        else {
                            if (target.length == 0) {
                                angular.forEach($scope.exportOptions, function (option) {
                                    if (option.value == cat) option.indeterminate = false;
                                });
                            }
                        }
                    }
                    else {
                        target.push(opt);
                        if (data.length == target.length != 0) {
                            parent.push(cat);
                            angular.forEach($scope.exportOptions, function (option) {
                                if (option.value == cat) option.indeterminate = false;
                            });
                        }
                        else if (data.length != target.length != 0) {
                            angular.forEach($scope.exportOptions, function (option) {
                                if (option.value == cat) option.indeterminate = true;
                            });
                        }
                    }
                    $scope.ExportError = '';
                },
                ExportData: function (dev, $scope, bll, modal, formHelper, copy) {
                    if ($scope.ExportSelection.length == 0 && $scope.ExportFileSelection.length == 0
                        && $scope.ExportActSelection.length == 0 && $scope.ExportReqSelection.length == 0
                        && $scope.ExportImgSelection.length == 0 && $scope.ExportBlockSelection.length == 0) {
                        DialogHandler.AddError('Nothing is selected!');
                        return;
                    }

                    $scope.ExportError = '';
                    $scope.Exportloading = true;
                    var verID;
                    if (copy && !versionCopy) verID = $scope.CopyAppInfo.Ver.ApplicationVersionID;
                    else if (copy && versionCopy) verID = $scope.importfromver.ver.ApplicationVersionID;
                    else verID = $scope.currentVersion.ver.ApplicationVersionID;

                    if ($scope.ExportSelection.indexOf(1) > -1) $scope.ExportFileSelection = [];

                    bll.ExportSettings(function (data) {
                        if (data.error_description != undefined && data.error_description != '') {
                            DialogHandler.AddError(data.error_description);
                            $scope.Exportloading = false;
                            $scope.ExportError = data.error_description;
                        }
                        else {
                            if (copy && !versionCopy) {
                                copyApp(dev, $scope, bll, modal, formHelper, data.Data.Content);
                            }
                            else if (copy && versionCopy) {
                                versionCopy = false;
                                copyVersion(dev, $scope, bll, modal, formHelper, data.Data.Content);
                            }
                            else {
								FileDownloadHelper.saveAsJsonFile($scope.application.ApplicationTitle + '_' + $scope.currentVersion.ver.Version, data.Data.Content);
								$scope.Exportloading = false;
                                modal.dismiss('ExportSettings');
                            }
                        }
                    }, {
                            VersionID: verID, options: $scope.ExportSelection, CompanyID: $scope.application.CompanyID,
                            FileOptions: $scope.ExportFileSelection, ActOptions: $scope.ExportActSelection,
                            ReqOptions: $scope.ExportReqSelection, ImgOptions: $scope.ExportImgSelection,
                            BlockOptions: $scope.ExportBlockSelection
                        });
                },
                ImportData: function (dev, $scope, bll, modal, formHelper, copy) {
                    if ($scope.iFile == '') {
                        $scope.ImportError = 'Invalid file!'
                        return;
                    }
                    $scope.Importloading = true;

                    angular.forEach($scope.importedText, function (imp) {
                        if (imp != undefined && imp.length != undefined) {
                            for (var idx = imp.length - 1; idx > -1; idx--) {
                                if (imp[idx].selected == false) {
                                    imp.splice(idx, 1);
                                }
                            }
                        }
                    });

                    var imgIds = [];
                    angular.forEach($scope.importedText.Images, function (img) {
                        imgIds.push(img.MediaAssetID);
                    });
                    $scope.importedText.Images = imgIds;

                    if (copy) {
                        copyApp(dev, $scope, bll, modal, formHelper, JSON.stringify($scope.importedText))
                    }
                    else {
                        var VersionID = $scope.currentVersion.ver.ApplicationVersionID;

                        bll.ImportSettings(function (data) {
                            if (data.error_description != undefined && data.error_description != '') {
                                $scope.Importloading = false;
                                DialogHandler.AddError(data.error_description);
                                $scope.ImportError = data.error_description;
                            }
                            else {
                                $scope.conflictLists = data.Data.Content;
                                void 0;
                                $scope.conflictCount = 0;
                                $scope.resolvedConflictCount = 0;
                                if ($scope.conflictLists.ActionList.length != 0 || $scope.conflictLists.BlockList.length != 0 || $scope.conflictLists.ReqList.length != 0 || $scope.conflictLists.targetFileErrors.length != 0 || $scope.conflictLists.copiedAssetsUrls.length != 0) {
                                    $scope.ExportImportMode = 3;
                                    replaceLists = { ActionList: [], ReqList: [], BlockList: [], targetFileErrors: [] };
                                    addLists = { ActionList: [], ReqList: [], BlockList: [], targetFileErrors: [] };
                                    angular.forEach($scope.conflictLists, function (confl) {
                                        $scope.conflictCount += confl.length;
                                    });
                                }
                                else {
                                    modal.dismiss('ExportSettings');
                                    DialogHandler.AddMessage('Import successful!');
                                    $scope.ReloadVersion();
                                }
                                $scope.Importloading = false;
                            }
                        }, { VersionID: VersionID, CompanyID: $scope.importedText.CompanyID, importSettings: JSON.stringify($scope.importedText) });
                    }
                },
                ImportLoad: function (dev, $scope, copy, hasAuthor) {
                    if ($scope.iFile == '') {
                        $scope.ImportError = 'Invalid file!'
                        return;
                    }
                    if (!dev) {
                        if (hasAuthor && $scope.CopyAppInfo.CompanyObject == undefined) {
                            $scope.ImportError = 'Author not selected!';
                            return;
                        }
                    }

                    $scope.Importloading = true;
                    try {
                        $scope.importedText = JSON.parse($scope.iFile);
                        var undefCount = 0;
                        var mediaIds = '';
                        angular.forEach($scope.importedText.Images, function (med) {
                            if (med.MediaAssetID != undefined) mediaIds += med.MediaAssetID + ',';
                            else mediaIds += med + ',';
                        });

                        mediaIds = mediaIds.substr(0, mediaIds.length - 1);
                        getMediaAssetsFileByIds(mediaIds, $scope)
                            .then(function () {
                                $scope.import = [];
                                $scope.importIndeterminate = [];

                                $scope.Importloading = false;
                                if ($scope.importedText.Files != undefined) {
                                    angular.forEach($scope.importedText.Files, function (file) {
                                        file.selected = true;
                                    });
                                    $scope.import.push('files');
                                    $scope.importIndeterminate['files'] = false;
                                } else undefCount++;
                                if ($scope.importedText.Actions != undefined) {
                                    angular.forEach($scope.importedText.Actions, function (act) {
                                        act.selected = true;
                                    });
                                    $scope.import.push('actions');
                                    $scope.importIndeterminate['actions'] = false;
                                } else undefCount++;
                                if ($scope.importedText.Requirements != undefined) {
                                    angular.forEach($scope.importedText.Requirements, function (req) {
                                        req.selected = true;
                                    });
                                    $scope.import.push('reqs');
                                    $scope.importIndeterminate['reqs'] = false;
                                } else undefCount++;
                                if ($scope.importedText.ConfigBlocks != undefined) {
                                    angular.forEach($scope.importedText.ConfigBlocks, function (block) {
                                        block.selected = true;
                                    });
                                    $scope.import.push('blocks');
                                    $scope.importIndeterminate['blocks'] = false;
                                } else undefCount++;
                                if ($scope.importedText.Images != undefined) {
                                    angular.forEach($scope.importedText.Images, function (img) {
                                        img.selected = true;
                                    });
                                    $scope.import.push('images');
                                    $scope.importIndeterminate['images'] = false;
                                } else undefCount++;

                                if (undefCount == 5) {
                                    $scope.ImportError = 'Invalid file!';
                                }
                                else $scope.ExportImportMode = 2;

                                if (copy) {
                                    $scope.ExportImportMode = 6;
                                    $scope.copyLoad = false;
                                }
                            });
                    }
                    catch (err) {
                        $scope.ImportError = 'Invalid file!'
                    }

                    $scope.Importloading = false;
                },
                SelectForImport: function ($scope, obj, cat, list) {
                    var count = 0, idx;
                    obj.selected = !obj.selected;
                    angular.forEach(list, function (ob) {
                        if (ob.selected) count++;
                    });
                    if (count != 0 && count != list.length) {
                        $scope.importIndeterminate[cat] = true;
                        idx = $scope.import.indexOf(cat);
                        if (idx > -1) {
                            $scope.import.splice(idx, 1);
                        }
                    }
                    else if (count != 0 && count == list.length) {
                        $scope.importIndeterminate[cat] = false;
                    }
                    else $scope.importIndeterminate[cat] = false;
                    if (count == list.length) {
                        idx = $scope.import.indexOf(cat);
                        if (idx == -1) {
                            $scope.import.push(cat);
                        }
                    }
                    if (count == 0) {
                        idx = $scope.import.indexOf(cat);
                        if (idx > -1) {
                            $scope.import.splice(idx, 1);
                        }
                    }
                },
                ToggleImportAll: function ($scope, list, cat, event) {
                    var idx = $scope.import.indexOf(cat);
                    if (idx > -1) {
                        $scope.import.splice(idx, 1);
                        $scope.importIndeterminate[cat] = false;
                    } else {
                        $scope.import.push(cat);
                        $scope.importIndeterminate[cat] = false;
                    }
                    angular.forEach(list, function (obj) {
                        if (idx > -1) obj.selected = false;
                        else obj.selected = true;
                    });
                    if (event != undefined)
                        event.stopPropagation();
                },
                ConflictResolveAddReplace: function ($scope, obj, cat, replace) {
                    var idx;
                    switch (cat) {
                        case 'act':
                            if (replace) {
                                idx = addLists.ActionList.indexOf(obj);
                                if (idx > -1) {
                                    addLists.ActionList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                replaceLists.ActionList.push(obj);
                                obj.resolvedBy = 1;
                            }
                            else {
                                idx = replaceLists.ActionList.indexOf(obj);
                                if (idx > -1) {
                                    replaceLists.ActionList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                addLists.ActionList.push(obj);
                                obj.resolvedBy = 0;
                            }
                            break;
                        case 'req':
                            if (replace) {
                                idx = addLists.ReqList.indexOf(obj);
                                if (idx > -1) {
                                    addLists.ReqList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                replaceLists.ReqList.push(obj);
                                obj.resolvedBy = 1;
                            }
                            else {
                                idx = replaceLists.ReqList.indexOf(obj);
                                if (idx > -1) {
                                    replaceLists.ReqList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                addLists.ReqList.push(obj);
                                obj.resolvedBy = 0;
                            }
                            break;
                        case 'block':
                            if (replace) {
                                idx = addLists.BlockList.indexOf(obj);
                                if (idx > -1) {
                                    addLists.BlockList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                replaceLists.BlockList.push(obj);
                                obj.resolvedBy = 1;
                            }
                            else {
                                idx = replaceLists.BlockList.indexOf(obj);
                                if (idx > -1) {
                                    replaceLists.BlockList.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                addLists.BlockList.push(obj);
                                obj.resolvedBy = 0;
                            }
                            break;
                        case 'file':
                            if (replace) {
                                idx = addLists.targetFileErrors.indexOf(obj);
                                if (idx > -1) {
                                    addLists.targetFileErrors.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                replaceLists.targetFileErrors.push(obj);
                                obj.resolvedBy = 1;
                            } else {
                                idx = replaceLists.targetFileErrors.indexOf(obj);
                                if (idx > -1) {
                                    replaceLists.targetFileErrors.splice(idx, 1);
                                    $scope.resolvedConflictCount--;
                                    $scope.conflictCount++;
                                }
                                $scope.resolvedConflictCount++;
                                $scope.conflictCount--;
                                addLists.targetFileErrors.push(obj);
                                obj.resolvedBy = 0;
                            }
                            break;
                        default: break;
                    }
                },
                CancelResolveSelection: function ($scope, obj, cat) {
                    var idx;
                    obj.resolvedBy = undefined;
                    $scope.resolvedConflictCount--;
                    $scope.conflictCount++;
                    switch (cat) {
                        case 'act':
                            idx = replaceLists.ActionList.indexOf(obj);
                            if (idx > -1) replaceLists.ActionList.splice(idx, 1);
                            else {
                                idx = addLists.ActionList.indexOf(obj);
                                if (idx > -1) addLists.ActionList.splice(idx, 1);
                            }
                            break;
                        case 'req':
                            idx = replaceLists.ReqList.indexOf(obj);
                            if (idx > -1) replaceLists.ReqList.splice(idx, 1);
                            else {
                                idx = addLists.ReqList.indexOf(obj);
                                if (idx > -1) addLists.ReqList.splice(idx, 1);
                            }
                            break;
                        case 'block':
                            idx = replaceLists.BlockList.indexOf(obj);
                            if (idx > -1) replaceLists.BlockList.splice(idx, 1);
                            else {
                                idx = addLists.BlockList.indexOf(obj);
                                if (idx > -1) addLists.BlockList.splice(idx, 1);
                            }
                            break;
                        case 'file':
                            idx = replaceLists.targetFileErrors.indexOf(obj);
                            if (idx > -1) replaceLists.targetFileErrors.splice(idx, 1);
                            else {
                                idx = addLists.targetFileErrors.indexOf(obj);
                                if (idx > -1) addLists.targetFileErrors.splice(idx, 1);
                            }
                            break;
                        default:
                    }
                },
                ResolveConflicts: function ($scope, modal, bll) {
                    $scope.Importloading = true;
                    bll.ResolveImportConflict(function (data) {
                        if (data.error_description != undefined) {
                            DialogHandler.AddError('Error occured while trying to resolve conflicts!');
                        }
                        else {
                            $scope.loadApps();
                            modal.dismiss('ExportSettings');
                            $scope.EditAppModel(true);
                            DialogHandler.AddMessage('Import successful!');
                            $scope.getAppVerList($scope.application.ApplicationID);
                            $scope.ReloadVersion(true);
                        }
                        $scope.Importloading = false;
                    }, { replaceLists: replaceLists, addLists: addLists, appVersionID: $scope.application.ApplicationVersionID })
                },
                CloseImportResolve: function ($scope, modal, nothingToResolve) {
                    $scope.ReloadVersion(true);
                    $scope.loadApps();
                    $scope.getAppVerList($scope.application.ApplicationID);
                    if (nothingToResolve) {
                        $scope.loadApps();
                        modal.dismiss('ExportSettings');
                        $scope.EditAppModel(true);
                        DialogHandler.AddMessage('Import successful!');
                        $scope.getAppVerList($scope.application.ApplicationID);
                        $scope.ReloadVersion(true);
                    }
                    else DialogHandler.AddError('Import closed before finishing! Review settings before using.');
                    modal.dismiss('ExportSettings');
                },
                ExportAll: function ($scope, none) {
                    $scope.ExportFileSelection = [];
                    $scope.ExportActSelection = [];
                    $scope.ExportReqSelection = [];
                    $scope.ExportImgSelection = [];
                    $scope.ExportBlockSelection = [];
                    if (none) $scope.ExportSelection = [];
                    else {
                        if ($scope.versionFilesList != undefined && $scope.versionFilesList.length > 0) $scope.ExportSelection.push(1);
                        if ($scope.exeActionsList != undefined && $scope.exeActionsList.length > 0) $scope.ExportSelection.push(2);
                        if ($scope.appRequirements != undefined && $scope.appRequirements.length > 0) $scope.ExportSelection.push(3);
                        if ($scope.application.AttchedAssetFiles != undefined && $scope.application.AttchedAssetFiles.length > 0) $scope.ExportSelection.push(4);
                        if ($scope.blocksList != undefined && $scope.blocksList.length > 0) $scope.ExportSelection.push(5);
                        angular.forEach($scope.versionFilesList, function (verFile) {
                            $scope.ExportFileSelection.push(verFile.FileID);
                        });
                        angular.forEach($scope.exeActionsList, function (exeAct) {
                            $scope.ExportActSelection.push(exeAct.ApplicationVersionExecutableActionID);
                        });
                        angular.forEach($scope.appRequirements, function (reqs) {
                            $scope.ExportReqSelection.push(reqs.HardwareRequirementID);
                        });
                        angular.forEach($scope.application.AttchedAssetFiles, function (file) {
                            $scope.ExportImgSelection.push(file.MediaAssetID);
                        });
                        angular.forEach($scope.blocksList, function (block) {
                            $scope.ExportBlockSelection.push(block.BlockID);
                        });
                    }

                    angular.forEach($scope.exportOptions, function (opt) {
                        opt.indeterminate = false;
                    });
                },
                ImportAll: function ($scope, none) {
                    if (none == undefined) none = false;
                    if (none) {
                        $scope.import = [];
                    }
                    else {
                        $scope.import = ['files', 'actions', 'reqs', 'images', 'blocks'];
                    }
                    $scope.importIndeterminate['files'] = false;
                    $scope.importIndeterminate['actions'] = false;
                    $scope.importIndeterminate['reqs'] = false;
                    $scope.importIndeterminate['images'] = false;
                    $scope.importIndeterminate['blocks'] = false;

                    angular.forEach($scope.importedText, function (imp) {
                        if (imp != undefined && imp.length != undefined) {
                            for (var idx = imp.length - 1; idx > -1; idx--) {
                                imp[idx].selected = !none
                            }
                        }
                    });
                },
                SelectAppForCopy: function ($scope, bll) {
                    if ($scope.provider != undefined || ($scope.CopyAppInfo.CompanyObject != undefined && $scope.CopyAppInfo.Ver != undefined)) {
                        $scope.copyLoad = true;
                        getExportData($scope, bll, $scope.CopyAppInfo.Ver.ApplicationVersionID, $scope.CopyAppInfo.ApplicationId, true);
                        $scope.ExportImportMode = 5;
                    }
                },
                ToAppInbox: function ($scope) {
                    var app = {};
                    app.ApplicationTitle = $scope.application.ApplicationTitle;
                    app.IsExternal = $scope.application.IsExternal;
                    app.ApplicationVersionID = $scope.currentVersion.ver.ApplicationVersionID;

                    _appStore.SendToAppInbox(function (data) {
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        }
                        else {
                            DialogHandler.AddMessage(data.message);
                        }
                    }, app);
                },
                GetCustomCode: function ($scope, bll) {
                    bll.getCustomCode(function (data) {
                        if (data.hasError || data.error != undefined) {
                            DialogHandler.AddError(data.error);
                        } else {
                            if ($scope.CustomCode == undefined) $scope.CustomCode = {};
                            $scope.CustomCode.text = data.content;
                        }
                    }, $scope.application.ApplicationVersionID);
                },
                SaveCustomCode: function ($scope, bll) {
                    var data = {};
                    data.CustomCode = $scope.CustomCode.text;
                    data.AppVerID = $scope.application.ApplicationVersionID;
                    bll.saveCustomCode(function (data) {
                        if (data.hasError || data.error != undefined) {
                            DialogHandler.AddError(data.error);
                        }
                        else DialogHandler.AddMessage('Code saved.');
                    }, data);
                },
                getFileUrl: function (bll, fileID) {
                    bll.getFileUrl(fileID);
                }
            }

            function getMediaAssetsFileByIds(mediaIds, $scope) {
                var deferred = $q.defer();
                if (mediaIds == '') {
                    $scope.importedText.Images = undefined;
                    deferred.resolve();
                    return deferred.promise;
                }
                else {
                    MediaAssetsBLL.getMediaAssetsFileByIds(function (data) {
                        $scope.importedText.Images = data.error_description == undefined ?
                            data.Data.Content : undefined;
                        deferred.resolve();
                    }, mediaIds);
                    return deferred.promise;
                }
            }

            function setApps(data, $scope) {
                $scope.AppsDataLoading = false;
                $scope.appList = data.Data.Content;
                if ($scope.appList.length != 0) {
                    $scope.AppFilter.TotalCount = $scope.appList[0].TotalCount;
                } else {
                    $scope.AppFilter.TotalCount = 0;
                }
            }

            function loadApps($scope, bll) {
                if ($scope.AppFilter.CompanyObject != null)
                    $scope.AppFilter.CompanyId = $scope.AppFilter.CompanyObject.CompanyID;
                else $scope.AppFilter.CompanyId = 0;
                $scope.dataLoading = true;
                bll.GetApps(function (data) { setApps(data, $scope); $scope.dataLoading = false; }, $scope.AppFilter);
            }

            function loadVersionFiles($scope, bll) {
                if ($scope.application != undefined) {
                    bll.GetVersionFiles(function (data) {
						$scope.dataLoading = false;
						$scope.verFilesList = [];
                        if (data.hasError || data.error != undefined) {
                            DialogHandler.AddError(data.error);
                        } else {
                            $scope.verFilesList = data.content;
                        }
                    }, $scope.application.ApplicationVersionID);
                }
            }

            function loadExeActions($scope, bll) {
                bll.getExecutableActions(function (data) {
                    $scope.dataLoading = false;
                    if (data.hasError || data.error != undefined) {
                        DialogHandler.AddError(data.error);
                    } else {
                        $scope.execActionsList = data.content;
                    }
                }, $scope.application.ApplicationVersionID);
            }

            function loadRequirements($scope) {
                _appStore.getAppRequirements(function (data) {
                    $scope.appReqs = data;
                    $scope.dataLoading = false;
                }, $scope.application.ApplicationVersionID)
            }

            function loadConfiguration($scope, newGroup, reload) {
                if ($scope.Configurator == undefined || reload == true) {
                    $scope.blockLoad = true;
                    campaignBLL.loadAppVersionConfiguration(function () {
                        $scope.index = [];
                        if (newGroup == undefined) {
                            $scope.Configurator = {};
                            $scope.Configurator.ConfigBlocks = $scope.blockList;
                        }
                        $scope.Configurator.AppConfigurations = [];
                        $scope.Configurator.ConfigBlocks = $filter('orderBy')($scope.Configurator.ConfigBlocks, 'GroupOrder');
                        triggerConfigChange($scope);

                        ConfigBlockHelper.loadBlocks($scope.Configurator.ConfigBlocks, $scope.Configurator.AppConfigurations);
                        $timeout(function () {
                            $scope.blockLoad = false;
                        }, 500);
                    }, $scope.currentVersion.ver.ApplicationVersionID);
                }
            }

            function loadBlocks($scope, configurator, reload) {
                campaignBLL.getConfiguratorBlocks(function (data) {
                    $scope.dataLoading = false;
                    $scope.blockList = data.Data.Content;
                    var noGridData = false, settings;

                    for (var bl = 0; bl < $scope.blockList.length; bl++) {
                        if (!$scope.blockList[bl].GridData) {
                            noGridData = true;
                            $scope.blockList[bl].GridData = ConfigBlockHelper.getGridData($scope.blockList[bl].BlockName);
                            $scope.blockList[bl].GridDatao = JSON.parse($scope.blockList[bl].GridData);
                        }
                        else {
                            try {
                                $scope.blockList[bl].GridDatao = JSON.parse($scope.blockList[bl].GridData);
                            }
                            catch (e) {
                                void 0;
                                noGridData = true;
                                $scope.blockList[bl].GridData = ConfigBlockHelper.getGridData($scope.blockList[bl].BlockName);
                                $scope.blockList[bl].GridDatao = JSON.parse($scope.blockList[bl].GridData);
                            }
                        }
                        if (!$scope.blockList[bl].Settings) {
                            $scope.blockList[bl].Settings = ConfigBlockHelper.getExtraSettings($scope.blockList[bl].BlockName);
                            settings = JSON.parse($scope.blockList[bl].Settings);
                            $scope.blockList[bl].Interactions = settings.Interaction == 'N/A' ? 'N/A' : JSON.stringify(settings.Interaction);
                        }
                        else {
                            if ($scope.blockList[bl].Settings != 'N/A') {
                                try {
                                    var gridData = (JSON.parse($scope.blockList[bl].Settings));
                                    if (gridData.Interaction == undefined && gridData.GridData == undefined) {
                                        $scope.blockList[bl].Interactions = gridData;
                                    }
                                }
                                catch (e) {
                                    DialogHandler.AddError('Invalid extra settings were detected for ' + $scope.blockList[bl].Label + '. Default value will be shown.');
                                    void 0;
                                    $scope.blockList[bl].Settings = ConfigBlockHelper.getExtraSettings($scope.blockList[bl].BlockName);
                                    settings = JSON.parse($scope.blockList[bl].Settings);
                                    $scope.blockList[bl].Interactions = settings.Interaction == 'N/A' ? 'N/A' : JSON.stringify(settings.Interaction);
                                }
                            }
                            else {
                                var settingsExtra = ConfigBlockHelper.getExtraSettings($scope.blockList[bl].BlockName);
                                $scope.blockList[bl].Settings = settingsExtra;
                                var parseSettings = JSON.parse(settingsExtra);
                                $scope.blockList[bl].Interactions = parseSettings.Interaction == 'N/A' ? 'N/A' : JSON.stringify(parseSettings.Interaction);
                            }
                        }
                        //check invalid default val
                        if (!isValidBlockJSON($scope.blockList[bl].DefaultValue, $scope.blockList[bl].Label, 'Default value')) $scope.blockList[bl].DefaultValue = createBlockErrorJSON($scope.blockList[bl].DefaultValue);
                        //check invalid Options
                        if (!isValidBlockJSON($scope.blockList[bl].Options, $scope.blockList[bl].Label, 'Options')) $scope.blockList[bl].Options = createBlockErrorJSON($scope.blockList[bl].Options);
                        //ValidationParameters
                        if (!isValidBlockJSON($scope.blockList[bl].ValidationParameters, $scope.blockList[bl].Label, 'ValidationParameters')) $scope.blockList[bl].ValidationParameters = createBlockErrorJSON($scope.blockList[bl].ValidationParameters);
                    }

                    $scope.blockList = $filter('orderBy')($scope.blockList, 'GroupOrder');

                    $scope.groupList = [];

                    for (var idx = 0; idx < $scope.blockList.length; idx++) {
                        if ($scope.groupList.indexOf($scope.blockList[idx].GroupName) != -1) continue;
                        else $scope.groupList.push($scope.blockList[idx].GroupName);
                    }

                    if (noGridData) {
                        angular.forEach($scope.groupList, function (groupName) {
                            var filter = $filter('filter')($scope.blockList, { GroupName: groupName }, true);
                            filter = $filter('orderBy')(filter, 'GridDatao.row');
                            if (filter.length > 1) {
                                for (var bidx = 1; bidx < filter.length; bidx++) {
                                    if (filter[bidx].GridDatao.sizeX == 3 && filter[bidx - 1].GridDatao.sizeX == 3 && filter[bidx - 1].GridDatao.col == 0) {
                                        filter[bidx].GridDatao.row = filter[bidx - 1].GridDatao.row;
                                        filter[bidx].GridDatao.col = 3;
                                    }
                                    else {
                                        filter[bidx].GridDatao.row = filter[bidx - 1].GridDatao.row + filter[bidx - 1].GridDatao.sizeY;
                                        filter[bidx].GridDatao.col = 0;
                                    }
                                }
                            }
                        });
                    }

                    if (configurator == true) {
                        deleteBlockList = [];
                        loadConfiguration($scope, undefined, reload);
                    }
                }, $scope.application.ApplicationVersionID)
            }

            function createBlockErrorJSON(faultyValue) {
                return '{ "FailingValue":"' + faultyValue + '"}'
            }

            function isValidBlockJSON(checkValue, Label, ErrSourceField) {
                if (checkValue) {
                    if (checkValue != 'N/A') {
                        try {
                            JSON.parse(checkValue);
                            return true;
                        }
                        catch (e) {
                            DialogHandler.AddError('Corrupt ' + ErrSourceField + ' value:' + Label);
                            void 0;
                            return false;
                        }
                    }
                }
                return true;
            }

            function triggerConfigChange($scope) {
                if ($scope.blockChange == 0) $scope.blockChange = 1;
                else $scope.blockChange = 0;
            }

            function getAppImages($scope) {
                if ($scope.application.AttchedAssetFiles != null) {
                    for (var i = 0; i < $scope.application.AttchedAssetFiles.length; i++) {
                        if ($scope.application.MainScreenURL == $scope.application.AttchedAssetFiles[i].FileURL) {
                            $scope.application.AttchedAssetFiles[i].isDefault = true;
                            $scope.showBigger.isActive = true;
                        }
                        else {
                            $scope.application.AttchedAssetFiles[i].isDefault = false;
                        }
                    }
                }
                $scope.dataLoading = false;
            }

            function switchEditVersionTab($scope, bll, tab, reload) {
                $scope.editVersionTabs.Active = tab;
                setRoute('Applications/' + $scope.application.ApplicationID + '/Versions/' + $scope.application.Version + '/' + tab);
                switch (tab) {
                    case 'Requirements':
                        loadRequirements($scope);
                        $scope.addReqList = [];
                        removeReqList = [];
                        break;
                    case 'Configurator':
                        $scope.ConfiguratorSaving = false;
                        $scope.groupBlocks = undefined;
                        $scope.groupList = undefined;
                        loadBlocks($scope, true, reload);
                        break;
                    case 'ExeActions':
                        loadExeActions($scope, bll);
                        break;
                    case 'Version':
                        loadVersionFiles($scope, bll);
                        break;
                    case 'CustomCode':
                        $scope.getCustomCode();
                        break;
                }
            }

            function reloadVersion(dev, $scope, bll, formHelper, copy) {
                $scope.dataLoading = true;
                bll.GetAppByIdAdmin(function (data) {
                    if (data.error_description != undefined) {
                        DialogHandler.AddError(data.error_description);
                        $scope.currentVersion.ver = $scope.appVerList[$scope.appVerList.length - 1];
                        return;
                    }
                    $scope.application = data.Data.Content;
                    $scope.newMediaList = [];

                    $scope.removeMediaList = [];
                    $scope.defaultThumbnail = {};

                    //Image tab load
                    $scope.showBigger = {};
                    $scope.showBigger.FileUrl = null;
                    getAppImages($scope);
                    $scope.showBigger.FileUrl = $scope.application.MainScreenURL;

                    switchEditVersionTab($scope, bll, $scope.editVersionTabs.Active, true);

                    formHelper.ResetFormErrors();

                    if (copy) {
                        $scope.AppDetailsForm = {
                            ApplicationID: $scope.application.ApplicationID,
                            Description: $scope.application.Description,
                            ShortDescription: $scope.application.ShortDescription,
                            ApplicationTitle: $scope.application.ApplicationTitle,
                            InteractionID: $scope.application.InteractionID,
                            Price: $scope.application.Price,
                            RentingPrice: $scope.application.RentingPrice,
                            State: $scope.application.State,
                            UrlLink: $scope.application.UrlLink,
                            IsExternal: $scope.application.IsExternal,
                            IsBackground: $scope.application.IsBackground,
                            IsWebApp: $scope.application.IsWebApp,
                            IsServiceApp: $scope.application.IsServiceApp
                        };
                    }

                    $scope.AppVerDetailsForm = {
                        Version: $scope.application.Version,
                        ApplicationVersionID: $scope.application.ApplicationVersionID,
                        IsActive: $scope.application.IsActive,
                        ConfigurationExternalURL: $scope.application.ConfigurationExternalURL,
                        ExecutableName: $scope.application.ExecutableName,
                        Description: $scope.application.ChangeLog,
                        Status: $scope.application.Status,
                        CreateAppExternalURL: $scope.application.CreateAppExternalURL,
                        DeleteAppExternalURL: $scope.application.DeleteAppExternalURL,
                        CopyAppExternalURL: $scope.application.CopyAppExternalURL,
                        CopyAppExternalUrlPOST: $scope.application.CopyAppExternalUrlPOST,
                        InAppSwitch: $scope.application.InAppSwitch,
                        AutoSave: $scope.application.AutoSave
                    };
                    if (dev) {
                        $scope.noChangeAllowed = false;
                        if ($scope.AppVerDetailsForm.Status == 'Public') $scope.noChangeAllowed = true;
                    }
                }, $scope.application.ApplicationID, $scope.currentVersion.ver == undefined ? $scope.application.ApplicationVersionID : $scope.currentVersion.ver.ApplicationVersionID);
            }

            function getAppList($scope, bll) {
                $scope.appListLoading = true;
                bll.GetAllApps(function (data) { $scope.AppList = data; $scope.appListLoading = false; });
            }

            function confirmconfigSave($scope, modal) {
                if (modal.open('ConfiguratorBlockDelete', 'inviteColleagueModal', null, { rejectedCallback: function () { deleteBlockID = undefined, groupDelete = undefined } }))
                    $scope.blockDelete = 2;
            }

            function resetExportValues($scope) {
                $scope.iFile = '';
                $scope.copyLoad = true;
                $scope.Importloading = false;
                $scope.ImportError = '';
                $scope.ExportError = '';
			}

            function resetExportArrayValues($scope) {
                $scope.exportOptions = [];
                $scope.ExportSelection = [];
                $scope.ExportFileSelection = [];
                $scope.ExportActSelection = [];
                $scope.ExportReqSelection = [];
                $scope.ExportImgSelection = [];
                $scope.ExportBlockSelection = [];
                $scope.Exportloading = false;
                $scope.newAssetPath = [];
            }

            function getExportData($scope, bll, VerID, AppID, copy, versionCopy) {
                if (copy || versionCopy) {
                    bll.GetAppByIdAdmin(function (data) {
                        $scope.application = data.Data.Content;
                        gatherExportData($scope, bll, VerID)
                    }, AppID, VerID);
                }
                else gatherExportData($scope, bll, VerID);
            }

            function gatherExportData($scope, bll, VerID) {
                bll.getExecutableActions(function (data) {
                    if (data.hasError || data.error != undefined) DialogHandler.AddError(data.error);
                    else $scope.exeActionsList = data.content;
                    _appStore.getAppRequirements(function (data) {
                        $scope.appRequirements = data;
                        campaignBLL.getConfiguratorBlocks(function (data) {
                            $scope.blocksList = data.Data.Content;
                            bll.GetVersionFiles(function (data) {
                                $scope.versionFilesList = data.content;
                                if ($scope.versionFilesList != undefined && $scope.versionFilesList.length > 0) $scope.exportOptions.push({ label: 'Files', value: 1, indeterminate: false });
                                if ($scope.exeActionsList != undefined && $scope.exeActionsList.length > 0) $scope.exportOptions.push({ label: 'Actions', value: 2, indeterminate: false });
                                if ($scope.appRequirements != undefined && $scope.appRequirements.length > 0) $scope.exportOptions.push({ label: 'Requirements', value: 3, indeterminate: false });
                                if ($scope.application.AttchedAssetFiles != undefined && $scope.application.AttchedAssetFiles.length > 0) $scope.exportOptions.push({ label: 'Images', value: 4, indeterminate: false });
                                if ($scope.blocksList != undefined && $scope.blocksList.length > 0) $scope.exportOptions.push({ label: 'ConfigBlocks', value: 5, indeterminate: false });
                                $scope.copyLoad = false;
                            }, VerID);
                        }, VerID);
                    }, VerID)
                }, VerID);
            }

            function copyApp(dev, $scope, bll, modal, formHelper, copiedData) {
                var appID = 0;
                var companyID = 0;
                if ($scope.CopyAppInfo.ApplicationId != undefined && $scope.CopyAppInfo.ApplicationId != '') appID = $scope.CopyAppInfo.ApplicationId;
                if ($scope.CopyAppInfo.CompanyObject != undefined) companyID = $scope.CopyAppInfo.CompanyObject.CompanyID;
                bll.copyApplication(function (data) {
                    $scope.Importloading = false;
                    if (data.error_description != undefined) {
                        DialogHandler.AddError(data.error_description);
                    }
                    else {
                        var returnData = data.Data.Content;
                        if (returnData.VersionID != 0 && returnData.ApplicationID != 0) {
                            if ($scope.application != undefined) {
                                $scope.application.ApplicationID = returnData.ApplicationID;
                                $scope.application.ApplicationVersionID = returnData.VersionID;
                            }
                            else {
                                $scope.application = {};
                                $scope.application.ApplicationID = returnData.ApplicationID;
                                $scope.application.ApplicationVersionID = returnData.VersionID;
                            }

                            $scope.currentVersion = { ver: { ApplicationVersionID: returnData.VersionID } };
                            $scope.isNewApp = false;
                            $scope.conflictCount = 0;
                            $scope.resolvedConflictCount = 0;
                            $scope.conflictLists = { targetFileErrors: data.Data.Content.targetFileErrors, copiedAssetsUrls: data.Data.Content.copiedAssetsUrls };
                            if ($scope.conflictLists.targetFileErrors.length != 0 || $scope.conflictLists.copiedAssetsUrls.length != 0) {
                                $scope.ExportImportMode = 3;
                                replaceLists = { ActionList: [], ReqList: [], BlockList: [], targetFileErrors: [] };
                                addLists = { ActionList: [], ReqList: [], BlockList: [], targetFileErrors: [] };
                                $scope.conflictCount += $scope.conflictLists.targetFileErrors.length;
                            }
                            else {
                                $scope.EditAppModel(true);
                                reloadVersion(dev, $scope, bll, formHelper, true);
                                $scope.getAppVerList(returnData.ApplicationID);
                                loadApps($scope, bll);
                                modal.dismiss('ExportSettings');
                                $scope.Exportloading = false;
                            }
                        }
                        else {
                            DialogHandler.AddError('Error while copying application!');
                        }
                    }
                }, { importSettings: copiedData, ApplicationID: appID, CompanyID: companyID });
            }

            function copyVersion(dev, $scope, bll, modal, formHelper, copiedData) {
                var companyID = 0;
                var appVer = $scope.currentVersion.ver.ApplicationVersionID;
                if ($scope.application != undefined) companyID = $scope.application.CompanyID;
                bll.copyVersion(function (data) {
                    $scope.Importloading = false;
                    if (data.error_description != undefined) {
                        DialogHandler.AddError(data.error_description);
                    }
                    else {
                        var returnData = data.Data.Content;
                        if (returnData.VersionID != 0 && returnData.ApplicationID != 0) {
                            $scope.isNewApp = false;
                            $scope.conflictCount = 0;
                            $scope.resolvedConflictCount = 0;
                            $scope.conflictLists = { targetFileErrors: data.Data.Content.targetFileErrors, copiedAssetsUrls: data.Data.Content.copiedAssetsUrls };
                            reloadVersion(dev, $scope, bll, formHelper);
                            modal.dismiss('ExportSettings');
                            $scope.Exportloading = false;
                            DialogHandler.AddMessage('Import successful!');
                        }
                        else {
                            DialogHandler.AddError('Error while importing version!');
                        }
                    }
                }, { importSettings: copiedData, CompanyID: companyID, VersionID: appVer });
            }

            function scrollToConfigGroup(group) {
                var id = '#ConfiguratorPartial_' + group;
                $timeout(function () {
                    var el = $(id);
                    var elpos = el.position();
                    $('.modal').animate({
                        scrollTop: elpos.top
                    }, 400);
                }, 2200);
            }

            function setRoute(route) {
                var routePrefix = $location.path().startsWith('/ToolBox/AppAdmin') ? '/ToolBox/AppAdmin/' : $location.path().startsWith('/ToolBox/Admin/') ? '/ToolBox/Admin/' : '';
                if (routePrefix != '')
                    $location.path(routePrefix + route, false);
                SessionData.setReturnURL();
            }
        }]);